import { type PimProductV11 } from '@redteclab/api/clients/bully'

export const productAccessorIsCoolingProduct = (
  product: PimProductV11,
): boolean => {
  return product.flags?.cool.active ?? false
}
